// extracted by mini-css-extract-plugin
module.exports = {"consulta":"ConsultaAlimentos_consulta__2P_5A","mostrar":"ConsultaAlimentos_mostrar__2_RpA"};